package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteDispatchResult
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/{id}/dispatch (DOM-02). */
class DispatchRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String, skipOptimization: Boolean? = null): RouteDispatchResult =
        repository.dispatchRoute(routeId, skipOptimization)
}
